// extracted by mini-css-extract-plugin
module.exports = {"root":"ArmyMobilizedSupport_root__3DM2p","placeholder":"ArmyMobilizedSupport_placeholder__7iHk7","text":"ArmyMobilizedSupport_text__3GeMt"};